import { jsx as l, jsxs as f } from "react/jsx-runtime";
import { forwardRef as y } from "react";
import { c as n } from "./cn-DlLpp5ix.js";
const N = {
  sm: "h-8 px-2.5 text-sm",
  md: "h-10 px-3 text-sm",
  lg: "h-12 px-3.5 text-md"
}, v = {
  sm: { left: "pl-8", right: "pr-8" },
  md: { left: "pl-9", right: "pr-9" },
  lg: { left: "pl-10", right: "pr-10" }
}, _ = {
  base: "bg-bg-base",
  elevated: "bg-bg-elevated"
}, E = y(function({
  size: e = "md",
  surface: h = "base",
  invalid: x,
  iconLeft: r,
  iconRight: o,
  suffix: t,
  monospace: c = !1,
  type: d = "text",
  className: g,
  disabled: s,
  readOnly: a,
  ["aria-invalid"]: m,
  ...p
}, u) {
  const i = x ?? (m === !0 || m === "true"), b = n(
    "block w-full rounded-lg border outline-none transition-colors",
    "placeholder:text-tertiary text-primary",
    N[e],
    _[h],
    c ? "font-mono" : "font-sans",
    r ? v[e].left : "",
    o || t ? v[e].right : "",
    i ? "border-error-border focus-visible:border-error focus-visible:shadow-[0_0_0_3px_var(--error-bg)]" : "border-default hover:border-strong focus-visible:border-accent focus-visible:shadow-ring-focus",
    s ? "cursor-not-allowed opacity-60" : "",
    a ? "cursor-default" : "",
    g
  );
  return !r && !o && !t ? /* @__PURE__ */ l(
    "input",
    {
      ref: u,
      type: d,
      className: b,
      disabled: s,
      readOnly: a,
      "aria-invalid": i || void 0,
      ...p
    }
  ) : /* @__PURE__ */ f("div", { className: n("relative flex items-center", s ? "opacity-60" : ""), children: [
    r ? /* @__PURE__ */ l(
      "span",
      {
        className: n(
          "pointer-events-none absolute inset-y-0 flex items-center text-tertiary",
          e === "sm" ? "left-2.5" : e === "md" ? "left-3" : "left-3.5"
        ),
        "aria-hidden": "true",
        children: r
      }
    ) : null,
    /* @__PURE__ */ l(
      "input",
      {
        ref: u,
        type: d,
        className: b,
        disabled: s,
        readOnly: a,
        "aria-invalid": i || void 0,
        ...p
      }
    ),
    o || t ? /* @__PURE__ */ f(
      "span",
      {
        className: n(
          "pointer-events-none absolute inset-y-0 flex items-center gap-1 text-tertiary",
          e === "sm" ? "right-2.5" : e === "md" ? "right-3" : "right-3.5"
        ),
        children: [
          o,
          t ? /* @__PURE__ */ l("span", { className: c ? "font-mono text-secondary" : "text-secondary", children: t }) : null
        ]
      }
    ) : null
  ] });
});
export {
  E as I
};
//# sourceMappingURL=Input-uO0r0zqM.js.map
